import axios from 'axios';
import secureStorage from "../utils/secureStorage";

const API_ENDPOINTS = {
    development: 'https://app-test-001.quickcom.ma/api',
    staging: 'https://app-preprod-001.quickcom.ma/api',
    production: 'https://app-prod-001.quickcom.ma/api',
    integration: 'https://app-int-001.quickcom.ma/api'
};

// WhatsApp microservice base URLs per environment
const WHATSAPP_ENDPOINTS = {
    development:  import.meta.env?.VITE_WHATSAPP_URL || 'https://ws-send.quickcom.ma',
    staging:      import.meta.env?.VITE_WHATSAPP_URL || 'https://ws-send.quickcom.ma',
    production:   import.meta.env?.VITE_WHATSAPP_URL || 'https://ws-send.quickcom.ma',
    integration:  import.meta.env?.VITE_WHATSAPP_URL || 'https://ws-send.quickcom.ma',
};

// Get environment from Vite with fallback
const currentEnv = import.meta.env?.VITE_APP_ENV || 'integration';
export const API_URL = API_ENDPOINTS[currentEnv];
export const WHATSAPP_URL = WHATSAPP_ENDPOINTS[currentEnv];

// Create axios instance
export const api = axios.create({
    baseURL: API_URL,
    headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
    }
});

// WhatsApp microservice axios instance
export const whatsappApi = axios.create({
    baseURL: WHATSAPP_URL,
    timeout: 30000,
    headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
    }
});

// Flag to prevent multiple logout attempts
let isLoggingOut = false;

// Add auth header interceptor
api.interceptors.request.use(async config => {
    const token = await secureStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Add response interceptor to handle token expiration
api.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;
        if (
            error.response &&
            error.response.status === 401
        ) {
            isLoggingOut = true;

            // Clear storage
            await secureStorage.removeItem('token');
            await secureStorage.removeItem('user');
            await secureStorage.removeItem('selectedAccount');
            await secureStorage.removeItem('accounts');
            await secureStorage.removeItem('_email');
            await secureStorage.removeItem('_id');

            // Redirect to login page
            window.location.href = '/login';

            // You could also dispatch an event to show a notification
            const expiredEvent = new CustomEvent('token-expired');
            window.dispatchEvent(expiredEvent);

            return Promise.reject(error);
        }

        return Promise.reject(error);
    }
);

export default API_ENDPOINTS;

// Variant API Functions
export const updateVariant = async (variantId, data) => {
  const accountId = await secureStorage.getItem("selectedAccount");
  return api.put(`/variants/${variantId}`, data, {
    headers: { 'X-account-id': accountId.id }
  });
};

export const deleteVariant = async (variantId) => {
  const accountId = await secureStorage.getItem("selectedAccount");
  return api.delete(`/variants/${variantId}`, {
    headers: { 'X-account-id': accountId.id }
  });
};

export const createVariant = async (data) => {
  const accountId = await secureStorage.getItem("selectedAccount");
  return api.post('/variants', data, {
    headers: { 'X-account-id': accountId.id }
  });
};

export const getVariant = async (variantId) => {
  const accountId = await secureStorage.getItem("selectedAccount");
  return api.get(`/variants/${variantId}`, {
    headers: { 'X-account-id': accountId.id }
  });
};

export const getProductVariants = async (productId) => {
  const accountId = await secureStorage.getItem("selectedAccount");
  return api.get(`/products/${productId}/variants`, {
    headers: { 'X-account-id': accountId.id }
  });
};
